const ACTIVITY_SESSION_VERSION = 2;
const ACTIVITY_SESSION_IDLE_MS = 30 * 60 * 1000;
const SESSION_ID_PATTERN = /^[a-zA-Z0-9_-]{16,96}$/;

function createActivitySessionId() {
  return globalThis.crypto?.randomUUID?.()
    || `activity_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

function localDayKey(date) {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

function parseStoredSession(storedValue) {
  if (!storedValue) return null;
  try {
    const parsed = JSON.parse(storedValue);
    const startedAt = new Date(parsed?.startedAt);
    const lastHeartbeatAt = new Date(parsed?.lastHeartbeatAt);
    if (
      parsed?.version !== ACTIVITY_SESSION_VERSION
      || !SESSION_ID_PATTERN.test(String(parsed?.id || ''))
      || Number.isNaN(startedAt.getTime())
      || Number.isNaN(lastHeartbeatAt.getTime())
    ) {
      return null;
    }
    return { ...parsed, startedAt, lastHeartbeatAt };
  } catch {
    return null;
  }
}

export function resolveActivitySession(storedValue, { at = new Date(), createId = createActivitySessionId } = {}) {
  const currentAt = new Date(at);
  if (Number.isNaN(currentAt.getTime())) throw new Error('Некорректное время сессии активности');

  const stored = parseStoredSession(storedValue);
  const idleMs = stored ? currentAt.getTime() - stored.lastHeartbeatAt.getTime() : Infinity;
  const canReuse = stored
    && idleMs >= 0
    && idleMs <= ACTIVITY_SESSION_IDLE_MS
    && localDayKey(stored.startedAt) === localDayKey(currentAt);
  const id = canReuse ? stored.id : createId();
  if (!SESSION_ID_PATTERN.test(String(id || ''))) throw new Error('Некорректный ID сессии активности');

  return {
    version: ACTIVITY_SESSION_VERSION,
    id,
    startedAt: (canReuse ? stored.startedAt : currentAt).toISOString(),
    lastHeartbeatAt: currentAt.toISOString()
  };
}
